import { useEffect, useState } from 'react';

export default function Alert({ message, type, onClose }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      onClose();
    }, 2000);
    return () => clearTimeout(timer);
  }, [onClose]);

  if (!visible) return null;

  return (
    <div className={`fixed top-4 right-4 z-50 p-4 rounded-lg shadow-lg text-white ${type === 'success' ? 'bg-green-500' : 'bg-red-500'}`}>
      <div className="flex items-center gap-2">
        <i className={`ri-${type === 'success' ? 'check' : 'error-warning'}-line text-xl`}></i>
        <span>{message}</span>
      </div>
    </div>
  );
}